export default __webpack_public_path__ + "static/media/no-event.55f2bca7.svg";